import localeProvider from "csi/page/localeProvider";
import { routerStore } from "csi/state/rootStore";
import declare from "dojo/_base/declare";
import { C8RequestError } from "src/c8-platform/core/request";
import EditCustomAttribute from "src/SiteAdmin/EditCustomAttribute";
import AttributeDefinitionPopup from "./AttributeDefinitionPopup";
import AttributeDefinitionStore from "./AttributeDefinitionStore";
import { getRootRequest } from "./AttributeDefinitionValidationService";

const AttributeDefinitionEditController = declare(EditCustomAttribute, {
	/** @param {AttributeDefinitionStore} store */
	store: null,

	/**
	 * @override
	 * Open React dialog
	 */
	async preProcess() {
		const cache = this.getCache();
		const store = this.store = new AttributeDefinitionStore(this.getNode(), this.getParent(), this.getCache(), localeProvider);

		let request = getRootRequest(this);
		if (request) {
			request = cache.reduceNodesRequest(request);
		}
		if (request) {
			this.widget.annotateViewRequest(request);

			const res = await request.go();
			cache.cacheResponse(res);
		}
		
		this.useReactDialog(routerStore.openDialog(AttributeDefinitionPopup, {
			onClose: ()=>{
				this.onCancelReactDialog();
			}, 
			onSave: ()=>{
				if (!store.validate()) {
					return;
				}
				this.repeatReactForm = false;
				this.save();
			},
			title: this.getTitle(),
			store,
		}));
	},

	/**
	 * create new attribute
	 */
	save(): void {
		this.processReact(this.store.saveForm());
	},

	/**
	 * @param err @override
	 */
	_onPublishError: function(err: C8RequestError): void {
		this.store.setFormError(err);
		this.inherited(arguments);
	},

});

export = AttributeDefinitionEditController;
